import React from "react";

function CyclesPage({ dayunSlice, birthY, _backend, liunian3, actionGuidance, _narratives,
  reportNumber, lang }) {
  return (
    <div className="lr2-page" id="ch4">
      <div className="lr2-ph">
        <span className="lr2-ph-num">04</span>
        <div>
          <div className="lr2-ph-title">运势时间轴 · 大运流年</div>
          <div className="lr2-ph-sub">LUCK CYCLE · ANNUAL FORTUNE · 3-YEAR OUTLOOK</div>
        </div>
      </div>
      <div className="lr2-info-grid">
        <div>
          <div className="lr2-st">当前时间坐标</div>
          <table className="lr2-itable"><tbody>
            {dayunSlice[0] && <tr><td>当前大运</td><td><strong>{dayunSlice[0].ganzhi}</strong>（{(birthY||1980)+(dayunSlice[0].start_age||0)}–{(birthY||1980)+(dayunSlice[0].end_age||0)}）</td></tr>}
            <tr><td>2026 流年</td><td><strong>{_backend?.current_period?.liunian || "丙午"}</strong></td></tr>
            <tr><td>当前流月</td><td>{_backend?.current_period?.liuyue || "—"}</td></tr>
            <tr><td>本月质量</td><td><strong style={{color:"#2D6A4F"}}>{_backend?.current_period?.period_quality || (lang==="zh"?"—":"—")}</strong></td></tr>
          </tbody></table>
        </div>
        <div>
          <div className="lr2-st">大运序列</div>
          <div className="lr2-tl">
            {dayunSlice.map((d,i)=>(
              <div key={i} className={"lr2-tli"+(i===0?" current":"")}>
                <div className="lr2-tdot"/>
                {i===0 && <div className="lr2-tbadge">当前大运</div>}
                <div className="lr2-tperiod">{(birthY||1980)+(d.start_age||0)}–{(birthY||1980)+(d.end_age||0)} · {d.start_age}–{d.end_age}岁</div>
                <div className="lr2-tgz">{d.ganzhi}大运</div>
                <div className="lr2-ttheme">{d.theme || d.quality || "—"}</div>
                <div className="lr2-tdesc">{d.description || (lang==="zh"?"—":"—")}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="lr2-section">
        <div className="lr2-st">未来 3 年运势评分</div>
        <div className="lr2-lbars">
          {liunian3.map((y,i)=>{
            const score = y.score || 6;
            const cls = score >= 7.5 ? "high" : score >= 5 ? "medium" : "low";
            return (
              <div key={i} className="lr2-lrow">
                <span className="lr2-lyear">{y.year}</span>
                <span className="lr2-lgz">{y.ganzhi}</span>
                <span className="lr2-ltheme">{y.theme}</span>
                <div className="lr2-ltrack"><div className={"lr2-lfill "+cls} style={{width:(score*10)+"%"}}/></div>
                <span className="lr2-lnum">{score.toFixed(1)}</span>
              </div>
            );
          })}
        </div>
      </div>
      {actionGuidance.length > 0 && (
        <div className="lr2-section">
          <div className="lr2-st">行动建议 · 关键指引</div>
          <ul className="lr2-actions">
            {actionGuidance.slice(0,3).map((a,i)=>(
              <li key={i}>
                <span className="lr2-anum">{i+1}</span>
                <span className="lr2-atext">{a}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {_narratives?.yearly_overview && (
        <div className="lr2-section" style={{marginTop:18}}>
          <div className="lr2-st">运势总览 · AI 解读</div>
          <div style={{fontSize:"13.5px",color:"#333",lineHeight:1.9}}>
            {_narratives.yearly_overview.split("\n").filter(Boolean).map((para,i)=>(
              <p key={i} style={{marginBottom:10}}>{para}</p>
            ))}
          </div>
        </div>
      )}
      <div className="lr2-pf"><span className="lr2-pf-label">澄光能量 · {reportNumber}</span><span className="lr2-pf-seal lr2-pf-current">4</span></div>
    </div>
  );
}

export default CyclesPage;
